<template>
  <v-sheet rounded outlined class="pa-3">
    <div class="dd-eyebrow mb-1">
      <v-icon x-small class="mr-1">mdi-comment-text-outline</v-icon>{{ $t('riskMitigationComments') }}
    </div>
    <span class="text-body-2 grey--text text--darken-2">{{ comment }}</span>
  </v-sheet>
</template>

<script>
export default {
  name: 'MitigationCommentPreview',

  props: {
    comment: {
      type: String,
      required: true
    }
  }
}
</script>
